import React, { useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route , Navigate} from "react-router-dom";


//redux components
import { connect } from "react-redux";
import { Dispatch } from 'redux';

import DefaultLayout from './layouts/DefaultLayout'
import AuthLayout from './layouts/AuthLayout';

//to create theme
import { ThemeProvider, CssBaseline, createTheme } from '@mui/material'
import useSettings from './hooks/useSettings'
import { createCustomTheme } from './theme'
import actions from './redux/actions/global.actions';
import { RootState } from './redux/reducers/reducers';

interface Props {
  token: RootState['auth']['token']
  resetAll:()=>void;
}

function App({
  token,
  resetAll
}:Props) {
  const { settings } = useSettings()
  const theme = createCustomTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: 'LIGHT'//settings.theme,

  })

  useEffect(() => {
    resetAll()
  }, [])

 const getAuth =  useCallback(() => {
  var auth = false  
  auth = !!localStorage.getItem('access_token');

  return auth; // Adjust this logic based on your authentication state
}, [token])

const isAuthenticated=  getAuth()

console.log('isAuthenticated', isAuthenticated)

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <CssBaseline />
        <Routes>
          <Route path="/auth/*" element={isAuthenticated ? <Navigate to="/validations" /> : <AuthLayout />} />

          <Route path="/*" element={isAuthenticated ? <DefaultLayout /> : <Navigate to="/auth/login"/>} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>


  );
}

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  resetAll: ()=>dispatch(actions.resetAll())
});

export default connect(mapStateToProps,
  mapDispatchToProps)(App);


